import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Platforms from "./pages/Platforms";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsOfService from "./pages/TermsOfService";
import EventsUpPrivacy from "./pages/EventsUpPrivacy";
import EventsUpCookiePolicy from "./pages/EventsUpCookiePolicy";
import EventsUp from "./pages/EventsUp";
import TrustCenter from "./pages/TrustCenter";
import DPA from "./pages/DPA";
import SubProcessors from "./pages/SubProcessors";
import Request from "./pages/Request";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

function AppShell() {
  const { pathname } = useLocation();
  const hideChrome = pathname === "/eventsup";
  return (
    <div className="min-h-screen flex flex-col">
      {!hideChrome && <div className="print:hidden"><Navbar /></div>}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/platforms" element={<Platforms />} />
          <Route path="/eventsup" element={<EventsUp />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/trust" element={<TrustCenter />} />
          <Route path="/dpa" element={<DPA />} />
          <Route path="/subprocessors" element={<SubProcessors />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/eventsup-privacy" element={<EventsUpPrivacy />} />
          <Route path="/eventsup-cookie-policy" element={<EventsUpCookiePolicy />} />
          <Route path="/request" element={<Request />} />
        </Routes>
      </main>
      {!hideChrome && <div className="print:hidden"><Footer /></div>}
    </div>
  );
}

export default App;
